export default __webpack_public_path__ + "static/media/stmaryofangels.de9a6a1f.jpg";